import { CampoExtraRequest } from './bin-campo-extra.model';
import { BinRequest } from './formularios/bin-base-request.model';

export class BinGenericRequest {
    camposExtra: Array<CampoExtraRequest>;
    baseBine: BinRequest;
    rol: string;
    comentarioOpe: string;
    procedencia: string;
    origenInfo: number;
    binesList: string;
    idGrupo: number;
    constructor() {
        this.baseBine = new BinRequest();
        this.camposExtra = new Array<CampoExtraRequest>();
    }
}


